import * as yup from 'yup';

export const roleValidationSchema = {
  name: yup.string().required(),
  icon: yup.string().required(),
  active: yup.boolean().required(),
  groupEntitlements: yup.array().of(yup.number()).min(1).required()
};

export const isStepValid = (step, values) => {
  switch (step) {
    case 0:
      return yup.object().shape(roleValidationSchema).isValidSync(values);
    default:
      return false;
  }
};
